import React, { Fragment } from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";

import { routes } from "Constant/routes";

import { getStepLabel } from "../../SignalWizard.helpers";
import { STEPPER_STEPS } from "../../SignalWizard.types";
import {
    ActiveDot,
    Badge,
    Brand,
    BrandLink,
    BrandLogo,
    ExitButton,
    Header,
    Kbd,
    Separator,
    StepChevron,
    StepItem,
    Stepper,
} from "./WizardHeader.styled";

const getStepState = (index, activeIndex) => {
    if (index < activeIndex) return "done";
    if (index === activeIndex) return "active";
    return "upcoming";
};

/** `onStepClick` is only offered for steps the user already completed. */
const WizardHeader = ({ language, step, onStepClick, onExit }) => {
    const activeIndex = STEPPER_STEPS.indexOf(step);

    return (
        <Header>
            <Brand>
                <BrandLink to={routes.home} data-cy="wizard-logo">
                    <BrandLogo
                        src="/assets/images/signal-sight.png"
                        alt="SignalSight"
                    />
                </BrandLink>
                <Separator>/</Separator>
                <Badge>
                    {language?.tracker_wizard?.title ?? "Tracker Wizard"}
                </Badge>
            </Brand>

            <Stepper role="list" aria-label="Steps">
                {STEPPER_STEPS.map((stepKey, index) => {
                    const state = getStepState(index, activeIndex);
                    const isClickable = state === "done" && !!onStepClick;
                    return (
                        <Fragment key={stepKey}>
                            {index > 0 && <StepChevron />}
                            <StepItem
                                role="listitem"
                                $state={state}
                                disabled={!isClickable}
                                disableRipple
                                onClick={() => onStepClick?.(stepKey)}
                                aria-current={
                                    state === "active" ? "step" : undefined
                                }
                            >
                                {state === "active" && <ActiveDot />}
                                {state === "done" && <CheckCircleIcon />}
                                <span>
                                    {index + 1}{" "}
                                    {getStepLabel(stepKey, language)}
                                </span>
                            </StepItem>
                        </Fragment>
                    );
                })}
            </Stepper>

            <ExitButton
                onClick={onExit}
                disableRipple
                title={language?.tracker_wizard?.close_wizard ?? "Close Wizard"}
                data-cy="wizard-exit"
            >
                <span>{language?.tracker_wizard?.exit ?? "Exit"}</span>
                <Kbd>esc</Kbd>
                <CloseIcon />
            </ExitButton>
        </Header>
    );
};

export default WizardHeader;
